import { IEvent } from "@quest/adapter-interface";
import { ingenuity, SpineBase } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { BackgroundView } from "@quest/murka-games-behavior-panther/dist";
import { SlotConstants } from "@quest/slot-core";

/**
 * BackgroundViewGame class represents the visual aspects of the game's background,
 * responsible for rendering and displaying background elements, textures, or scenes.
 * It provides a view layer specifically dedicated to managing the visual presentation
 * of the background within the game.
 *
 * This class encapsulates the rendering logic and ensures a clear separation
 * between the visual representation of the background and the underlying game logic,
 * contributing to a modular and maintainable game architecture.
 */
export class BackgroundViewGame extends BackgroundView {
  private freegameBgPortraitrSpine: SpineBase;
  private freegameBgSpine: SpineBase;
  protected initializeComponents(): void {
    super.initializeComponents();
    this.freegameBgPortraitrSpine = this.getSpineById("freegame_idle_portrait");
    this.freegameBgSpine = this.getSpineById("freegame_idle_desktop");
  }
  protected resize(evt?: IEvent): void {
    super.resize(evt);
    if (!ingenuity.deviceEnv.isDesktop && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      this.handleFGBackgroundSpineVisibility();
    }
  }

     /**
       * Handle bonus spine visibility
       */
      private handleFGBackgroundSpineVisibility(): void {
        if(ingenuity.deviceEnv.isDesktop) return;
        if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.LANDSCAPE) {
          this.freegameBgSpine.alpha = 1;
          this.freegameBgSpine.visible = true;
          this.freegameBgPortraitrSpine.alpha = 0;
          this.freegameBgPortraitrSpine.visible = false;
        } else {
          this.freegameBgSpine.alpha = 0;
          this.freegameBgSpine.visible = false;
          this.freegameBgPortraitrSpine.alpha = 1;
          this.freegameBgPortraitrSpine.visible = true;

        }
      }
}
